
import React from 'react';
import { Col, Row} from 'antd';
import CropCharacterization from '../charts/CropCharacterization';
import BiodiversityMonitoring from '../charts/BiodiversityMonitoring';
import OrganicNonOrganic from '../charts/OrganicNonOrganic';
import SoilOrganicCarbon from '../charts/SoilOrganicCarbon';
import DataVisualizationFilterForm from './DataVisualizationFilterForm';


const DataVisualizationGrid = ({title}) => {
    return (
        <div style={{ backgroundColor: '#FFF', padding: 0}}>
            <DataVisualizationFilterForm/>
            <Row gutter={[12, 24]} style={{ marginTop: '30px'}}>
                <Col span={12} xs={24} xl={12}>
                    <div><CropCharacterization/></div>
                </Col>
                <Col span={12} xs={24} xl={12}>
                    <div><BiodiversityMonitoring/></div>
                </Col>
                <Col span={12} xs={24} xl={12}>
                    <div><OrganicNonOrganic/></div>
                </Col>
                <Col span={12} xs={24} xl={12}>
                    <div><SoilOrganicCarbon/></div>
                </Col>
            </Row>
        </div>
    );
}

export default DataVisualizationGrid;